// @ts-nocheck
import React from 'react';
import { useQuery } from '@apollo/client';
import InfiniteScroll from 'react-infinite-scroller';

import { Loader, Row, Col } from '@crehana/ui';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import OrganizationCourseCard from 'Jsx/Shared/OrganizationCourseCard';
import GET_ORGANIZATION_CLASSROOM_COURSES from 'Jsx/CrehanaLive/graphql/GetOrgClassroomCourses.b2b.graphql';

import {
  GetOrgClassroomCourses,
  GetOrgClassroomCoursesVariables,
} from 'Jsx/CrehanaLive/graphql/types/GetOrgClassroomCourses';

const ITEMS_PER_FETCH = 12;

const ClassroomCourseList = ({ organizationName, slug }) => {
  const { t } = useCrehanaLiveTranslations();

  const { data, loading, fetchMore, error } = useQuery<
    GetOrgClassroomCourses,
    GetOrgClassroomCoursesVariables
  >(GET_ORGANIZATION_CLASSROOM_COURSES, {
    variables: { slug, first: ITEMS_PER_FETCH, isActive: true, isDraft: false },
    context: { clientName: 'b2b' },
  });

  const customFetchMore = () => {
    fetchMore({
      variables: {
        slug,
        after: data?.organization?.classroomCourses?.pageInfo.endCursor,
        first: ITEMS_PER_FETCH,
        isActive: true,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev;
        }

        return {
          organization: {
            ...prev?.organization,
            classroomCourses: {
              ...prev?.organization?.classroomCourses,
              pageInfo:
                fetchMoreResult?.organization?.classroomCourses?.pageInfo,
              edges: [
                ...prev?.organization?.classroomCourses?.edges,
                ...fetchMoreResult?.organization?.classroomCourses?.edges,
              ],
              __typename: prev?.organization?.classroomCourses?.__typename,
            },
          },
        };
      },
    });
  };

  const courses =
    data?.organization?.classroomCourses?.edges.map(
      course => course?.node?.course,
    ) || [];

  const hasNextPage =
    data?.organization?.classroomCourses?.pageInfo.hasNextPage;

  if (error) {
    return (
      <div className="flex items-center justify-center mt-72">
        <p className="font-subtitle2 text-white">
          {t('ERROR_UPS_CLASS_ROOM_COURSE_LIST')}
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center mt-72">
        <Loader />
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex items-center justify-center">
        <h2 className="font-h3 text-white">
          {t('TITLE_CLASS_ROOM_COURSE_LIST_1')} {organizationName}{' '}
          {t('TITLE_CLASS_ROOM_COURSE_LIST_2')}
        </h2>
      </div>
      {courses.length === 0 ? (
        <div className="flex items-center justify-center mt-72">
          <p className="font-subtitle2 text-white">{t('NOT_COURSES')}</p>
        </div>
      ) : (
        <div className="relative mt-72">
          <InfiniteScroll
            loadMore={customFetchMore}
            hasMore={!!hasNextPage}
            loader={
              <div
                key="classroom-loader"
                className="flex justify-center w-full p-32"
              >
                <Loader />
              </div>
            }
            initialLoad={false}
            useWindow
          >
            <Row>
              {courses.map(course => (
                <Col
                  key={course?.originalId || 0}
                  sm={6}
                  md={4}
                  lg={3}
                  className="mb-24"
                >
                  <OrganizationCourseCard
                    promoImage={course?.promoImage || ''}
                    title={course?.title || ''}
                    url={course?.dashboardUrl || ''}
                    duration={course?.duration || 0}
                    progress={course?.progress}
                    level={course?.level}
                    className="bg-base-lighter"
                    isDark
                  />
                </Col>
              ))}
            </Row>
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};

export default ClassroomCourseList;
